import defaultColor from '@/components/color'
import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'
let op = JSON.parse(JSON.stringify(cpt_chart_column_option))
const dataText = JSON.stringify([
    {name:'Mon',value:120},
    {name:'Tue',value:200},
    {name:'Wed',value:150},
    {name:'Thu',value:80},
    {name:'Fri',value:70},
    {name:'Sat',value:110},
])
export default {
    attribute:{
        color:defaultColor,
        xAxis: {
            name: ' ',
            type: 'category',
            show: op.attribute.xAxis.show,
            axisLabel:{
                color: op.attribute.xAxis.axisLabel.color,
                fontSize:13
            },
            axisLine:{
                lineStyle: {
                    color: op.attribute.xAxis.axisLine.lineStyle.color
                }
            },
            splitLine: {//网格线
                show: false,
                lineStyle:{
                    color: op.attribute.xAxis.axisLine.lineStyle.color,
                }
            }
        },
        yAxis: {
            name: ' ',
            type: 'value',
            show: op.attribute.yAxis.show,
            axisLabel:{
                textStyle:{
                    color: op.attribute.yAxis.axisLabel.color,
                    fontSize: 13
                }
            },
            axisLine:{
                lineStyle:{
                    color: op.attribute.yAxis.axisLine.lineStyle.color
                }
            },
            splitLine: {//网格线
                show: op.attribute.yAxis.splitLine.show,
                lineStyle:{
                    type: 'dashed',
                    color: op.attribute.yAxis.splitLine.lineStyle.color
                }
            }
        },
        title: {
            text: '',
            left: 'center',
            top: 'top',
            textStyle:{
                fontSize:18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        boxDepth: 20,
        series:{
            label: {
                show: op.attribute.series.label.show, //数值
                color: '#ddd',
                fontSize: 13
            }
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm:{
        dataText:dataText, dataSource: 1, pollTime: 0
    },
}
